import * as React from 'react';

interface ISmallLoaderProps {
    text?: string;
    className?: string;
    textFirst?: boolean;
    inline?: boolean;
}

export const Loader = (props: ISmallLoaderProps) => {
    return (
        <div className={`loader-wrapper ${props.className ? props.className : ''}  ${props.inline ? 'inline' : ''}`}>
            <div className="small-loader">
                {
                    props.textFirst
                        ? <>{props.text ? props.text : ''} <span className="fas fa-spinner fa-spin"></span> </>
                        : <><span className="fas fa-spinner fa-spin"></span> {props.text ? props.text : ''}</>
                }
            </div>
        </div>
    );
};

export interface ICoundownProps {
    cnt: number;
}

export const CountDownLoader: React.FC<ICoundownProps> = (props: ICoundownProps) => {
    const [cnt, setCnt] = React.useState(props.cnt);

    React.useEffect(() => {
        const interval = window.setInterval(() => {

            setCnt(prevCounter => {
                if (prevCounter > 0) {
                    return prevCounter - 1;
                }
                else {
                    window.clearInterval(interval);
                    return -1;
                }

            });

        }, 1000);
        return () => window.clearInterval(interval);
    }, []);

    return <>
        {cnt > 0 ? cnt : ''}
    </>
}

export default Loader